import { NgModule } from '@angular/core';
import { SharedModule } from 'app/shared/shared.module';
import { ConfirmDialogComponent } from './dialogs-components/confirm-dialog/confirm-dialog.component';
import { DialogService } from 'app/dialogs/dialog.service';
import { DialogDescriptionComponent } from './dialogs-components/dialog-description/dialog-description.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { AlertDialogComponent } from './dialogs-components/alert-dialog/alert-dialog.component';
import { TranslateModule } from '@ngx-translate/core';
import { AppFormModule } from 'app/modules/app-form/app-form.module';
import { AppFormDialogComponent } from './dialogs-components/app-form-dialog/app-form-dialog.component';
import { FileListDialogComponent } from './dialogs-components/file-list-dialog/file-list-dialog.component';
import { ConfirmMultiMessageDialogComponent } from './dialogs-components/confirm-multimessage-dialog/confirm-multimessage-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
    imports: [
        SharedModule,
        FlexLayoutModule,
        TranslateModule.forChild(),
        MatDialogModule,
        AppFormModule
    ],
    declarations: [
        ConfirmDialogComponent,
        DialogDescriptionComponent,
        AlertDialogComponent,
        AppFormDialogComponent,
        FileListDialogComponent,
        ConfirmMultiMessageDialogComponent
    ],
    providers: [
        DialogService
    ]
})
export class DialogModule {
}
